import React from 'react';
import './MobileGrid.css'

const DetailComponentMobile = ({detailData}) => {  
    return (
     <div>
      {detailData.map(iteminner => ( 
         <div className="m-top60 details-row row"> 
          <div className='col-6'>Pickup Date: </div><div className='col-6'>{iteminner.PickupDate}</div>
          <div className='col-6'>Pickup Time: </div><div className='col-6'>{iteminner.PickupTime}</div> 
          <div className='col-6'>Pickup Point: </div><div className='col-6'>{iteminner.PickupPoint}</div>
          <div className='col-6'>Hotel: </div><div className='col-6'>{iteminner.Hotel}</div>
          <div className='col-6'>PAX: </div><div className='col-6'>{iteminner.PAX}</div>
          <div className='col-6'>participants: </div><div className='col-6'>{iteminner.participants}</div> 
          <div className='col-6'>RefNumber: </div><div className='col-6'>{iteminner.RefNumber}</div> 
          <div className='col-6'>Flight: </div><div className='col-6'>{iteminner.Flight}</div> 
          <div className='col-6'>Client: </div><div className='col-6'>{iteminner.Client}</div>
          </div> 
      ))}
      </div> 
    );
};
export default DetailComponentMobile;